var mmoLang = "en";
var mmoSettings = {};

function mmVolTimeLeft(endsAt) {
  if (!endsAt) return null;
  var left = new Date(endsAt).getTime() - Date.now();
  if (left <= 0) return mmoLang === "ar" ? "انتهى العرض" : "Offer expired";

  var d    = Math.floor(left / 86400000);
  var h    = Math.floor((left % 86400000) / 3600000);
  var m    = Math.floor((left % 3600000) / 60000);
  var s    = Math.floor((left % 60000) / 1000);
  var pad  = function(n) { return String(n).padStart(2, "0"); };
  var lbls = mmoSettings || {};

  if (d >= 3) {
    return d + (mmoLang === "ar" ? " " + (lbls.daysAr || "أيام") : " " + (lbls.daysEn || "Days")) + " " + pad(h) + ":" + pad(m) + ":" + pad(s);
  }
  var totalH = d * 24 + h;
  return pad(totalH) + ":" + pad(m) + ":" + pad(s);
}

function mmExtractId(id) {
  if (!id) return null;
  if (typeof id === "number") return id;
  var parts = String(id).split("/");
  var last = parts[parts.length - 1];
  return parseInt(last, 10);
}

function mmVolStartTimer(endsAt, el) {
  if (!endsAt || !el) return;
  var endMs = new Date(endsAt).getTime();
  if (isNaN(endMs)) return;

  function tick() {
    var left = endMs - Date.now();
    if (left <= 0) {
      el.textContent = mmoLang === "ar" ? "انتهى" : "Expired";
      return;
    }
    
    var d = Math.floor(left / 864e5), h = Math.floor((left % 864e5) / 36e5);
    var m = Math.floor((left % 36e5) / 6e4), s = Math.floor((left % 6e4) / 1e3);
    var pad = function(n) { return (n < 10 ? "0" : "") + n; };
    
    if (d >= 3) el.textContent = d + (mmoLang === "ar" ? " أيام " : "d ") + pad(h) + ":" + pad(m) + ":" + pad(s);
    else el.textContent = pad(d * 24 + h) + ":" + pad(m) + ":" + pad(s);
    
    setTimeout(tick, 1000);
  }
  tick();
}

/* ── Volume Discount Block ── */
async function runVolumeBlocks() {
  var containers = document.querySelectorAll("[data-mm-volume-block]");
  if (!containers.length) {
    if (window.mmOfferWidgetReady) window.mmOfferWidgetReady(false);
    else if (window.MMProductOffers) window.MMProductOffers.widgetReady(false);
    return;
  }
  for (var ci = 0; ci < containers.length; ci++) {
    (async function(container) {
      var shown = false;
      var shopDomain   = (window.Shopify && window.Shopify.shop) || "";
      var currentHandle = container.dataset.productHandle;
      var currentVarId  = mmExtractId(container.dataset.variantId);
      var basePrice     = parseInt(container.dataset.basePrice || "0", 10);

      mmoLang = (window.Shopify && window.Shopify.locale) || "en";
      if (mmoLang.indexOf("ar") === 0) mmoLang = "ar";
      if (mmoLang === "ar") container.classList.add("mm-rtl");

      var currencyCode  = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "BHD";

      if (basePrice <= 0) {
        if (window.mmOfferWidgetReady) window.mmOfferWidgetReady(false);
        else if (window.MMProductOffers) window.MMProductOffers.widgetReady(false);
        return;
      }

      // Sync currentVarId with main product form variant changes (once per page)
      (function syncVariant() {
        function readVariantFromUrl() {
          var p = new URLSearchParams(window.location.search).get("variant");
          if (p) { currentVarId = mmExtractId(p); }
        }
        readVariantFromUrl();
        if (!window.__mmOfferVariantSync) {
          window.__mmOfferVariantSync = true;
          document.addEventListener("change", function(e) {
            if (e.target && (e.target.name === "id" || e.target.dataset.productSelect) && e.target.closest("form[action*='/cart/add']")) {
              document.dispatchEvent(new CustomEvent("mm:offer-variant-sync", { detail: { variantId: mmExtractId(e.target.value) } }));
            }
          });
          document.addEventListener("variant:changed", function(e) {
            if (e.detail && e.detail.variant && e.detail.variant.id) {
              document.dispatchEvent(new CustomEvent("mm:offer-variant-sync", { detail: { variantId: mmExtractId(e.detail.variant.id) } }));
            }
          });
          document.addEventListener("variantChange", function(e) {
            if (e.detail && e.detail.variant && e.detail.variant.id) {
              document.dispatchEvent(new CustomEvent("mm:offer-variant-sync", { detail: { variantId: e.detail.variant.id } }));
            }
          });
          var _push = history.pushState.bind(history);
          history.pushState = function() { _push.apply(history, arguments); document.dispatchEvent(new Event("mm:offer-url-sync")); };
          window.addEventListener("popstate", function() { document.dispatchEvent(new Event("mm:offer-url-sync")); });
        }
        document.addEventListener("mm:offer-variant-sync", function(e) {
          if (e.detail && e.detail.variantId) currentVarId = e.detail.variantId;
        });
        document.addEventListener("mm:offer-url-sync", readVariantFromUrl);
      })();

      function formatMoney(cents) {
        if (window.MMOffers && window.MMOffers.fmtPrice) {
          return window.MMOffers.fmtPrice(cents, container);
        }
        var div = 1000;
        if (window.MMOffers && window.MMOffers.moneyDiv) div = window.MMOffers.moneyDiv(container);
        var tax = parseFloat(mmoSettings.taxPercentage || 10) / 100;
        var taxedCents = cents * (1 + tax);
        var c = currencyCode;
        var decimals = (c === 'BHD' || c === 'KWD' || c === 'OMR') ? 3 : 2;
        var amt = (taxedCents / div).toFixed(decimals);

        if (mmoLang === 'ar') {
          var sym = 'د.ب';
          if (c === 'SAR') sym = 'ر.س';
          else if (c === 'AED') sym = 'د.إ';
          return amt + ' ' + sym;
        }
        return amt + ' ' + c;
      }

      var rowsCont  = container.querySelector(".mm-vol-rows");
      var savingsEl = container.querySelector(".js-mm-vol-savings");
      var savingsVal = savingsEl ? savingsEl.querySelector(".js-mm-vol-sav-val, strong") : null;
      var atcBtn    = container.querySelector(".js-mm-vol-atc");

      try {
        var pf = window.__mmPrefetch;
        var url = window.MMOffers && window.MMOffers.offersApiUrl
          ? window.MMOffers.offersApiUrl({ productHandle: currentHandle })
          : "/apps/mm-app/api/offers?productHandle=" + encodeURIComponent(currentHandle);
        var resFn = pf ? pf.fetchOffers(currentHandle) : fetch(url).then(function(r) { return r.ok ? r.json() : { offers: [], settings: {} }; });
        var data = await resFn;
        if (!data) { return; }
        mmoSettings = data.settings || {};
        if (!data.offers || !data.offers.length) return;

        var volOffer = data.offers.find(function(o) { return o.type === "VOLUME"; });
        if (!volOffer || !volOffer.volumeTiers) return;

        var volConfig = [];
        try { volConfig = JSON.parse(volOffer.bundleItemsConfig || "[]"); } catch(e) {}

        // Fetch product data for variants
        var fetchProd = async function(h) {
           if (!h) return null;
           if (pf) return pf.fetchProduct(h);
           var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
           if (root.endsWith("/")) root = root.slice(0, -1);
           var r = await fetch(root + "/products/" + h + ".js");
           return r.ok ? r.json() : null;
        };

        var triggerP = await fetchProd(volConfig[0]?.handle || currentHandle);

        // UI Prep
        var variantConfigWrap = container.querySelector(".js-mm-vol-config");
        var variantListWrap   = container.querySelector(".js-mm-vol-variant-list");
        var variantTitle      = container.querySelector(".js-mm-vol-config-title");

        var titleEl = container.querySelector(".js-mm-vol-title");
        var sectionTitle = (mmoLang === "ar" ? volOffer.titleAr : volOffer.title) || volOffer.title || volOffer.name;
        if (titleEl) titleEl.textContent = sectionTitle || (mmoLang === "ar" ? (mmoSettings.buyMoreAr || "اشترِ أكثر، وفر أكثر") : (mmoSettings.buyMoreEn || "Buy More, Save More"));

        var savLblEl = container.querySelector(".js-mm-vol-savings-label");
        if (savLblEl) savLblEl.textContent = mmoLang === "ar" ? (mmoSettings.youSaveAr || "توفيرك") : (mmoSettings.youSaveEn || "You save");

        var btnPrefix = container.dataset.btnPrefix || (mmoLang === "ar" ? "أضف" : "Add");
        var btnSuffix = container.dataset.btnSuffix || (mmoLang === "ar" ? "إلى السلة" : "to Cart");

        var tiers = [];
        try { tiers = JSON.parse(volOffer.volumeTiers); } catch(e) {}
        if (!tiers.length) return;

        tiers.sort(function(a, b) { return a.qty - b.qty; });

        var currentVariant = null;
        if (triggerP && triggerP.variants) {
          currentVariant = triggerP.variants.find(function(v) {
            return String(v.id) === String(currentVarId);
          }) || triggerP.variants[0];
        }
        var volUnits = window.MMOffers && window.MMOffers.volumeUnitLabels
          ? window.MMOffers.volumeUnitLabels(triggerP, currentVariant, mmoLang === 'ar')
          : { one: mmoLang === 'ar' ? 'قطعة' : 'piece', many: mmoLang === 'ar' ? 'قطع' : 'pieces' };

        var hasTierQty1 = tiers.some(function(t) {
          return parseInt(t.qty, 10) === 1 && parseFloat(t.discount || 0) > 0;
        });

        function radioHtml(checked) {
          return '<div class="mm-vol-radio" aria-hidden="true"><div class="mm-vol-radio-dot"></div></div>' +
                 '<input type="radio" class="mm-vol-radio-input"' + (checked ? ' checked' : '') + ' tabindex="-1">';
        }

        function tierRow(opts) {
          var qty = opts.qty;
          var unitOne = opts.unitOne || volUnits.one;
          var unitMany = opts.unitMany || volUnits.many;
          var qtyLabel = qty === 1 ? ('1 ' + unitOne) : (qty + ' ' + unitMany);
          var meta = opts.meta || '';
          var disc = opts.disc || '';
          var price = opts.price || '';
          var active = opts.active ? ' active' : '';
          var badge = opts.badge ? '<span class="mm-vol-badge-rec">' + opts.badge + '</span>' : '';
          return '<div class="mm-vol-row' + active + '" data-qty="' + qty + '" data-discount="' + (opts.discount || 0) + '" data-dtype="' + (opts.dtype || '') + '">' +
            badge +
            radioHtml(!!opts.active) +
            '<div class="mm-vol-row__main">' +
              '<div class="mm-vol-row__qty">' + qtyLabel + '</div>' +
              (meta || disc ? '<div class="mm-vol-row__meta">' +
                (meta ? '<span class="mm-vol-row__sub">' + meta + '</span>' : '') +
                (disc ? '<span class="mm-vol-row__disc">' + disc + '</span>' : '') +
              '</div>' : '') +
            '</div>' +
            '<div class="mm-vol-row__price">' +
              (qty > 1 ? '<span class="mm-vol-row__price-label">' + (mmoLang === 'ar' ? 'الإجمالي' : 'Total') + '</span>' : '') +
              '<span class="mm-vol-row__price-val">' + price + '</span>' +
            '</div>' +
          '</div>';
        }

        var html = '';
        if (!hasTierQty1) {
          html = tierRow({
            qty: 1,
            active: true,
            discount: 0,
            dtype: '',
            meta: mmoLang === 'ar' ? 'السعر الأصلي' : 'Regular price',
            price: formatMoney(basePrice)
          });
        }

        var bestIdx = tiers.length - 1;
        tiers.forEach(function(tier, i) {
          var tierQty = parseInt(tier.qty, 10) || 1;
          var totalOrig = basePrice * tierQty;
          var dVal = parseFloat(tier.discount || 0);
          var discCents = volOffer.discountType === 'PERCENTAGE'
            ? Math.round(totalOrig * (dVal / 100))
            : Math.round(dVal * 100);
          var newTotal  = Math.max(0, totalOrig - discCents);
          var discLabel = volOffer.discountType === 'PERCENTAGE'
            ? dVal + '% ' + (mmoLang === 'ar' ? 'خصم' : 'off')
            : formatMoney(discCents) + ' ' + (mmoLang === 'ar' ? 'خصم' : 'off');
          var perUnit   = tierQty > 0 ? formatMoney(Math.round(newTotal / tierQty)) : '';

          html += tierRow({
            qty: tierQty,
            active: hasTierQty1 && tierQty === 1,
            discount: dVal,
            dtype: volOffer.discountType || 'PERCENTAGE',
            badge: i === bestIdx ? (mmoLang === 'ar' ? 'أفضل قيمة' : 'Best value') : '',
            meta: perUnit ? (perUnit + ' / ' + volUnits.one) : '',
            disc: discLabel,
            price: formatMoney(newTotal)
          });
        });

        rowsCont.innerHTML = html;
        container.hidden = false;
        container.classList.add("mmo-card--ready");
        shown = true;
        if (window.MMProductOffers) window.MMProductOffers.markVisible(container);

        // ── Mobile compact preview (disabled — always open) ──
        if (false && window.innerWidth <= 600) {
          var mVolTitle = sectionTitle || (mmoLang === "ar" ? "اشترِ أكثر، وفر أكثر" : "Buy More, Save More");
          var mVolImg = triggerP ? '<img src="' + (triggerP.featured_image || '') + '" alt="">' : '';
          var bestTier = tiers[tiers.length - 1];
          var mVolBadge = "";
          if (bestTier && volOffer.discountType === "PERCENTAGE") {
            mVolBadge = bestTier.discount + "% " + (mmoLang === "ar" ? "خصم" : "OFF");
          } else if (bestTier) {
            mVolBadge = mmoLang === "ar" ? "وفر" : "SAVE";
          }
          var mVolSub = tiers.length + " " + (mmoLang === "ar" ? "خيارات" : "Tiers");

          var mVolPreview = document.createElement("div");
          mVolPreview.className = "mm-mobile-preview";
          var vHdrStyle = getComputedStyle(container.querySelector(".mm-vol-header"));
          mVolPreview.style.background = vHdrStyle.background || "var(--mm-accent)";
          mVolPreview.style.borderRadius = "14px 14px 0 0";
          mVolPreview.innerHTML =
            '<div class="mm-mobile-preview-imgs">' + mVolImg + '</div>' +
            '<div class="mm-mobile-preview-info">' +
              '<div class="mm-mobile-preview-title">' + mVolTitle + '</div>' +
              '<div class="mm-mobile-preview-sub">' + mVolSub + '</div>' +
            '</div>' +
            (mVolBadge ? '<span class="mm-mobile-preview-badge">' + mVolBadge + '</span>' : '') +
            '<div class="mm-mobile-preview-arrow"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg></div>';

          container.insertBefore(mVolPreview, container.firstChild);
          container.classList.add("mm-mobile-collapsed");

          mVolPreview.addEventListener("click", function() {
            if (container.classList.contains("mm-mobile-collapsed")) {
              container.classList.remove("mm-mobile-collapsed");
              container.classList.add("mm-mobile-expanded");
            } else {
              container.classList.remove("mm-mobile-expanded");
              container.classList.add("mm-mobile-collapsed");
            }
          });
        }



        if (volOffer.endsAt) {
          var timerEl = container.querySelector(".js-mm-vol-timer");
          if (timerEl) {
            timerEl.hidden = false;
            timerEl.classList.add("mm-meta-visible");
            timerEl.style.setProperty("display", "inline-flex", "important");
            mmVolStartTimer(volOffer.endsAt, timerEl.querySelector("span"));
          }
        }

        if (volOffer.customerQuantity > 0) {
          var scarcityEl = container.querySelector(".js-mm-vol-scarcity");
          if (scarcityEl) {
            var slbl = mmoLang === "ar" ? (mmoSettings.onlyLeftAr || "متبقي {quantity} فقط!") : (mmoSettings.onlyLeftEn || "Only {quantity} left!");
            scarcityEl.innerHTML = '<span>' + slbl.replace("{quantity}", '<strong>' + volOffer.customerQuantity + '</strong>') + '</span>';
            scarcityEl.classList.add("mm-meta-visible");
            scarcityEl.style.setProperty("display", "block", "important");
          }
        }

        var selectedQty  = 1;
        var discountVal  = 0;
        var discountType = "PERCENTAGE";
        if (hasTierQty1) {
          var tier1 = tiers.find(function(t) { return parseInt(t.qty, 10) === 1; });
          discountVal = parseFloat((tier1 && tier1.discount) || 0);
          discountType = volOffer.discountType || "PERCENTAGE";
        }

        // Render variant pickers
        var renderVolumeVariants = function(qty) {
          if (!variantConfigWrap || !variantListWrap) return;
          if (qty <= 1 || !triggerP || !triggerP.variants || triggerP.variants.length <= 1) {
            variantConfigWrap.hidden = true;
            variantConfigWrap.style.display = "none";
            return;
          }

          var config = volConfig[0] || {};
          var mode = config.variantMode || "all";
          var selectedIds = config.selectedVariantIds || [];
          var filtered = triggerP.variants;
          
          if (mode === "specific" && selectedIds.length > 0) {
            var idSet = new Set(selectedIds.map(String).map(function(s) { 
               return s.indexOf("gid://") === 0 ? s.split("/").pop() : s;
            }));
            filtered = triggerP.variants.filter(function(v) { return idSet.has(String(v.id)); });
          }

          if (filtered.length <= 1) {
            variantConfigWrap.hidden = true;
            variantConfigWrap.style.display = "none";
            return;
          }

          if (variantTitle) variantTitle.textContent = mmoLang === "ar" ? "اختر الخيارات لكل قطعة" : "Choose options for each item";
          variantListWrap.innerHTML = "";
          for (var i = 0; i < qty; i++) {
            var row = document.createElement("label");
            row.className = "mmo-vol__variant";
            row.innerHTML =
              '<span class="mmo-vol__variant-idx">' + (i + 1) + '</span>' +
              '<span class="mmo-vol__variant-select-wrap">' +
                '<select class="mmo-vol__variant-select" aria-label="' + (mmoLang === "ar" ? "القطعة" : "Item") + ' ' + (i + 1) + '"></select>' +
                '<span class="mmo-vol__variant-chevron" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg></span>' +
              '</span>';
            var sel = row.querySelector("select");
            filtered.forEach(function(v) {
              var opt = document.createElement("option");
              opt.value = v.id;
              opt.textContent = v.title;
              sel.appendChild(opt);
            });
            variantListWrap.appendChild(row);
          }
          variantConfigWrap.hidden = false;
          variantConfigWrap.style.display = "";
        };

        renderVolumeVariants(1);

        atcBtn.disabled  = false;
        atcBtn.textContent = mmoLang === "ar" ? (mmoSettings.addToCartAr || "إضافة لمشترياتي") : (mmoSettings.addToCartEn || "Add Bundle to Cart");

        // Row click
        rowsCont.querySelectorAll(".mm-vol-row").forEach(function(row) {
          row.addEventListener("click", function() {
            rowsCont.querySelectorAll(".mm-vol-row").forEach(function(r) {
              r.classList.remove("active");
              var radio = r.querySelector("input[type='radio']");
              if (radio) radio.checked = false;
            });
            this.classList.add("active");
            var thisRadio = this.querySelector("input[type='radio']");
            if (thisRadio) thisRadio.checked = true;

            selectedQty  = parseInt(this.getAttribute("data-qty"), 10);
            discountVal  = parseFloat(this.getAttribute("data-discount") || "0");
            discountType = this.getAttribute("data-dtype") || "PERCENTAGE";

            renderVolumeVariants(selectedQty);

            if (selectedQty > 1 && discountVal > 0) {
              var origTotal = basePrice * selectedQty;
              var discCents = discountType === "PERCENTAGE"
                ? Math.round(origTotal * (discountVal / 100))
                : Math.round(discountVal * 100);
              if (savingsVal)  savingsVal.textContent = formatMoney(discCents);
              if (savingsEl)   savingsEl.style.display = "block";
            } else {
              if (savingsEl) savingsEl.style.display = "none";
            }
          });
        });

        // ATC
        atcBtn.addEventListener("click", async function() {
          this.disabled  = true;
          this.textContent = mmoLang === "ar" ? "جاري الإضافة..." : "Adding…";
          try {
            var items = [];
            var variantCounts = {};
            var bundleGroupId = "bg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);

            if (selectedQty > 1 && variantConfigWrap.style.display !== "none" && !variantConfigWrap.hidden) {
              var selects = variantListWrap.querySelectorAll("select");
              selects.forEach(function(s) {
                var vid = s.value;
                variantCounts[vid] = (variantCounts[vid] || 0) + 1;
              });
            } else {
              variantCounts[currentVarId] = selectedQty;
            }

            for (var vid in variantCounts) {
              items.push({ 
                id: mmExtractId(vid), 
                quantity: variantCounts[vid],
                properties: { 
                  _offerId: volOffer.id, 
                  _offerType: "VOLUME",
                  _bundleGroupId: bundleGroupId
                }
              });
            }

            var cartRes = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: items }),
            });
            if (!cartRes.ok) throw new Error(await cartRes.text());

            // Cart Attributes Sync
            var existingDeals = [];
            try {
              var cd = await (await fetch("/cart.js")).json();
              if (cd.attributes && cd.attributes._flash_deals_data) existingDeals = JSON.parse(cd.attributes._flash_deals_data);
            } catch (e) {}

            var volDeals = items.map(function(it) {
              return {
                variantId: String(it.id),
                type: "volume",
                offerId: volOffer.id,
                discountPercent: discountType === "PERCENTAGE" ? discountVal : 0,
                volumeQty: selectedQty // The tier quantity
              };
            });

            var newIds = new Set(volDeals.map(function(d) { return d.variantId; }));
            var merged = (window.MMOffers && window.MMOffers.mergeOfferDeals)
              ? window.MMOffers.mergeOfferDeals(existingDeals, volDeals, volOffer.id)
              : existingDeals.filter(function(d) { return d.offerId !== volOffer.id; }).concat(volDeals);

            await fetch("/cart/update.js", {
              method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ attributes: { _flash_deals_data: JSON.stringify(merged), _mm_country: window.MMOffers && window.MMOffers.marketCountry ? window.MMOffers.marketCountry() : "BH" } }),
            });              

            this.textContent = mmoLang === "ar" ? "تمت الإضافة!" : "Added!";
            var finalCart = await (await fetch("/cart.js")).json();
            if (window.MMOffers && window.MMOffers.openCartSheet) {
              await window.MMOffers.openCartSheet(finalCart);
            } else if (window.MMCart && window.MMCart.refresh) {
              var refreshed = await window.MMCart.refresh();
              if (window.MMCart.open) window.MMCart.open({ skipRefresh: true, cart: refreshed });
            }
            var btn = this;
            var volLabel = mmoLang === "ar" ? (mmoSettings.addToCartAr || "إضافة لمشترياتي") : (mmoSettings.addToCartEn || "Add Bundle to Cart");
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = volLabel;
            }, 1600);
          } catch(err) {
            this.disabled  = false;
            this.textContent = mmoLang === "ar" ? (mmoSettings.addToCartAr || "إضافة لمشترياتي") : (mmoSettings.addToCartEn || "Add Bundle to Cart");
            console.error("MM Volume ATC:", err);
          }
        });
      } catch(err) {
        console.error("MM Volume block:", err);
      } finally {
        if (window.MMProductOffers) window.MMProductOffers.widgetReady(shown);
        else if (window.mmOfferWidgetReady) window.mmOfferWidgetReady(shown);
      }
    })(containers[ci]);
  }
}
if (!document.querySelector('[data-mm-offer-landing]')) {
  document.addEventListener('DOMContentLoaded', runVolumeBlocks);
}
document.addEventListener('mm:offer-widgets-mount', runVolumeBlocks);
